import { useState, useCallback, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useJamesThreads } from '../../hooks/useJames';
import { JamesThreadList } from '../../components/james/JamesThreadList';
import { JamesChat } from '../../components/james/JamesChat';

export function James() {
  const { threadId: paramThreadId } = useParams<{ threadId?: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  // Draft typed into the Home "Ask James" box, handed over via router state.
  const initialDraft = (location.state as { draft?: string } | null)?.draft;
  const { data: threadsData, isLoading } = useJamesThreads();

  const [activeThreadId, setActiveThreadId] = useState<string | null>(paramThreadId ?? null);

  useEffect(() => {
    setActiveThreadId(paramThreadId ?? null);
  }, [paramThreadId]);

  const handleThreadSelect = useCallback((threadId: string | null) => {
    setActiveThreadId(threadId);
    if (threadId) {
      navigate(`/james/${threadId}`, { replace: true });
    } else {
      navigate('/james', { replace: true });
    }
  }, [navigate]);

  const handleNewThread = useCallback(() => {
    setActiveThreadId(null);
    navigate('/james', { replace: true });
  }, [navigate]);

  const handleThreadChange = useCallback((threadId: string | null) => {
    setActiveThreadId(threadId);
    if (threadId) {
      navigate(`/james/${threadId}`, { replace: true });
    }
  }, [navigate]);

  const threads = threadsData?.threads ?? [];

  return (
    <div className="absolute inset-0 flex flex-col overflow-hidden bg-surface-secondary lg:flex-row">
      <div className="min-h-0 w-full border-b border-border-light lg:w-[280px] lg:flex-shrink-0 lg:border-b-0 lg:border-r">
        <JamesThreadList
          threads={threads}
          activeThreadId={activeThreadId}
          onThreadSelect={handleThreadSelect}
          onNewThread={handleNewThread}
          isLoading={isLoading}
        />
      </div>

      <div className="min-h-0 min-w-0 flex-1">
        <JamesChat
          threadId={activeThreadId}
          onThreadChange={handleThreadChange}
          showClose={false}
          initialDraft={initialDraft}
        />
      </div>
    </div>
  );
}
